import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import helpers from 'utils/helpers';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      helpers.scrollToTop();
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
